import PropTypes from 'prop-types'
import { useState } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import { NumericFormat } from 'react-number-format'

import { toastErrorLog } from '../../helpers/toastErrorLog'
import * as presupuestosItemService from '../servicios/presupuestosItemService'
import styles from './PresupuestoForm.module.css'

const PresupuestoFormItem = ({ idPresupuesto, presupuestoData }) => {
  const [formData, setFormData] = useState({
    idPresupuesto,
    descripcion: '',
    cantidad: 0,
    moneda: 0,
    uMedida: 0,
    precio: 0,
    total: 0,
    alicuota: 0
  })
  const [clicked, setClicked] = useState(false)
  const [error, setError] = useState('')

  const onChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    setError('')
  }

  const calcularTotal = () => {
    setFormData((prev) => ({
      ...prev,
      total: prev.cantidad !== 0 && prev.precio !== 0 ? prev.cantidad * prev.precio : 0
    }))
  }

  const validarCampos = () => {
    if (!formData.descripcion.trim()) {
      return 'La descripción no puede estar vacía'
    }
    if (parseFloat(formData.precio) <= 0) {
      return 'El precio debe ser mayor que 0'
    }
    if (parseFloat(formData.cantidad) <= 0) {
      return 'La cantidad debe ser mayor que 0'
    }
    return ''
  }

  const onSubmit = async (e) => {
    try {
      e.preventDefault()
      setClicked(true)
      const errorMsg = validarCampos()
      if (errorMsg) {
        setError(errorMsg)
        setClicked(false)
        return
      }

      const item = {
        idPresupuesto: formData.idPresupuesto,
        descripcion: formData.descripcion,
        cantidad: parseFloat(formData.cantidad),
        moneda: parseInt(formData.moneda),
        uMedida: parseInt(formData.uMedida),
        precio: parseFloat(formData.precio),
        total: parseFloat(formData.total),
        alicuota: parseFloat(formData.alicuota) || 0
      }

      const { data } = await presupuestosItemService.insertar(item)
      presupuestoData({ ...data, alicuota: item.alicuota })
      setClicked(false)
    } catch (error) {
      const mensaje = `Ocurrió un error al grabar el presupuesto.`
      toastErrorLog(error, mensaje, 'presupuestos')
    } finally {
      setClicked(false)
    }
  }

  return (
    <div className={styles.detalleCard}>
      <p className={styles.itemFormTitulo}>Agregar Item</p>
      <form onSubmit={onSubmit}>
        <div className={styles.itemFormGrid}>
          <div className={`${styles.itemFormCampo} ${styles.itemFormCampoAncho}`}>
            <label htmlFor="descripcion" className={styles.detalleLabel}>
              Descripción Item
            </label>
            <input
              id="descripcion"
              name="descripcion"
              type="text"
              className={styles.campoInput}
              onChange={onChange}
              required
            />
          </div>
          <div className={styles.itemFormCampo}>
            <label htmlFor="cantidad" className={styles.detalleLabel}>
              Cantidad
            </label>
            <NumericFormat
              id="cantidad"
              name="cantidad"
              required
              onChange={onChange}
              onBlur={calcularTotal}
              className={styles.campoInput}
              thousandSeparator={false}
              decimalScale={2}
            />
          </div>
          <div className={styles.itemFormCampo}>
            <label htmlFor="alicuota" className={styles.detalleLabel}>
              % Alícuota IVA
            </label>
            <input
              id="alicuota"
              name="alicuota"
              type="number"
              className={styles.campoInput}
              value={formData.alicuota}
              onChange={onChange}
              min="0"
              max="100"
            />
          </div>
          <div className={styles.itemFormCampo}>
            <label htmlFor="moneda" className={styles.detalleLabel}>
              Moneda
            </label>
            <select
              id="moneda"
              name="moneda"
              className={styles.campoInput}
              onChange={onChange}
              required
            >
              <option value="">Seleccionar</option>
              <option value="1">Pesos</option>
            </select>
          </div>
          <div className={styles.itemFormCampo}>
            <label htmlFor="uMedida" className={styles.detalleLabel}>
              Unidad Medida
            </label>
            <select
              id="uMedida"
              name="uMedida"
              className={styles.campoInput}
              onChange={onChange}
              required
            >
              <option value="">Seleccionar</option>
              <option value="1">Unidad</option>
              <option value="2">Metros</option>
              <option value="3">Kilo</option>
            </select>
          </div>
          <div className={styles.itemFormCampo}>
            <label htmlFor="precio" className={styles.detalleLabel}>
              Precio
            </label>
            <NumericFormat
              id="precio"
              name="precio"
              required
              onChange={onChange}
              onBlur={calcularTotal}
              className={styles.campoInput}
              thousandSeparator={false}
              decimalScale={2}
              placeholder="$0.00"
            />
          </div>
          <div className={styles.itemFormCampo}>
            <span className={styles.detalleLabel}>Total</span>
            <div className={`${styles.campoInput} ${styles.campoTotal}`}>
              <NumericFormat
                value={formData.total}
                displayType={'text'}
                thousandSeparator={true}
                decimalSeparator={'.'}
                fixedDecimalScale={true}
                decimalScale={2}
                prefix={'$'}
              />
            </div>
          </div>
        </div>
        {error && <p className={styles.itemFormError}>{error}</p>}
        <div className={styles.itemFormAcciones}>
          <button type="submit" className="btn btn-volver-comprar" disabled={clicked}>
            {clicked ? <Spinner animation="border" role="status" size="sm" /> : 'Agregar Item'}
          </button>
        </div>
      </form>
    </div>
  )
}

PresupuestoFormItem.propTypes = {
  idPresupuesto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  presupuestoData: PropTypes.func.isRequired
}

export default PresupuestoFormItem
